@if (group) {
    <span class="group-name">{{ group.name }}</span>

    @for (board of group.links; track $index) {
        <span
            class="view-circle"
            [title]="board.name"
            [ngClass]="{'selected': selectedDashboardId === board.id.toString()}"
            (click)="onDashboardDotClicked(board.id.toString())"
        >
        </span>
    }
}
